// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_zLv","cls2":"AuthorHeader-cls2_EtC AuthorHeader-cls1_zLv"};